<div class='surface-0 min-h-screen flex flex-column justify-content-between'>
  <div id='home' class='landing-wrapper overflow-hidden'>
    <ip-layout-topbar [colorizedMenu]='colorizedMenu' [ngClass]='{"absolute z-5 w-full": colorizedMenu}'></ip-layout-topbar>

    <div class='layout-main'>
      <router-outlet></router-outlet>
    </div>
  </div>

  <ip-layout-footer></ip-layout-footer>
</div>
